import { Box, Dialog, Stack, Typography } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { useRef } from 'react';
import IconifyLegacy from 'src/components/iconify/iconify-legacy';

export default function RegisterCodes({ productDetailsHook }: any) {
  const inputFile = useRef<HTMLInputElement | null>(null);

  return (
    <Dialog
      open={!!productDetailsHook?.open}
      onClose={() => productDetailsHook?.onClose?.()}
      maxWidth="sm"
      fullWidth
    >
      <Stack
        spacing={4}
        sx={{
          p: 4,
        }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: 'space-between',
          }}
        >
          <Typography fontWeight="bold">Registrar códigos em massa</Typography>
          <ClearIcon
            onClick={() => productDetailsHook?.onClose?.()}
            sx={{
              cursor: 'pointer',
            }}
          />
        </Stack>
        <Stack
          spacing={4}
          sx={{
            alignItems: 'center',
          }}
        >
          <Typography variant="inherit">
            Baixe a planilha modelo e insira os códigos para o registro em massa
          </Typography>
          <Stack
            spacing={2}
            direction="row"
            sx={{
              alignItems: 'center',
              px: 8,
            }}
          >
            <a href="/Planilha_Exemplo.xlsx" download>
              <IconifyLegacy
                icon="mdi:file-table-box-multiple-outline"
                width={50}
                height={50}
                sx={{
                  color: 'black',
                }}
              />
            </a>
            <IconifyLegacy icon="mdi:arrow-right-bold" width={50} height={50} />
            <Box
              width={productDetailsHook?.fileName ? 'auto' : 50}
              px={productDetailsHook?.fileName ? 2 : 0}
              height={50}
              border="1px dashed"
              borderRadius={1}
              onClick={() => {
                if (inputFile.current) {
                  inputFile.current.click?.();
                }
              }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{
                '&:hover': {
                  cursor: 'pointer',
                },
              }}
            >
              <input
                onChange={(e) => productDetailsHook?.handleUpload?.(e)}
                ref={inputFile}
                type="file"
                accept=".xlsx"
                style={{ display: 'none' }}
              />
              {productDetailsHook?.fileName ? (
                <Typography>{productDetailsHook?.fileName}</Typography>
              ) : (
                <IconifyLegacy icon="mdi:file-upload" width={30} height={30} />
              )}
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </Dialog>
  );
}
